import { useState } from "react";
import "bootstrap/dist/css/bootstrap.min.css";
import {
  NavDropdown,
} from "react-bootstrap";

import {
  CustomeDropmain,
  NavcustomeDropdown,
  Drodownitemlist,
  CenterMenu,
} from "./customDropdownStyle";
import DonateNow from "./donateNow";
import NavDropdownItems from "./navDropdownItems";
import { MESSAGE } from "../../../utils/message";
import { useLocation } from "react-router-dom";

const CustomDropdown = () => {
  const [isHovered, setIsHovered] = useState<null | number>(null);

  const location = useLocation();
  const headers = [
    {
      title: MESSAGE.topRatedNonprofits,
      className: (location.pathname === "/awards/browse" || location.pathname === "/near-me" || location.pathname === "/toprated/about" || location.pathname === "/giving-guides" || location.pathname === "/about/cities" || location.pathname === "/about/categories-and-causes" || location.pathname === "/toprated/nominate") ? "active" : "",
      data: [
        {
          url: "/awards/browse",
          name: MESSAGE.topRatedList,
        },
        {
          url: "/near-me",
          name: MESSAGE.nonprofitsAndCharitiesNearMe,
        },
        {
          url: import.meta.env.VITE_CMS_URL + "toprated/about-top-rated-awards/",
          name: MESSAGE.aboutTopRatedAwards,
        },
        {
          url: import.meta.env.VITE_CMS_URL + "about/giving-guide/",
          name: MESSAGE.givingGuides,
        },
        {
          url: import.meta.env.VITE_CMS_URL + "about/top-cities/",
          name: MESSAGE.topCities,
        },
        {
          url: import.meta.env.VITE_CMS_URL + "about/top-causes/",
          name: MESSAGE.topCauses,
        },
        {
          url: import.meta.env.VITE_CMS_URL + "toprated/nominate/",
          name: MESSAGE.nominate,
        },
      ],
    },
    {
      title: MESSAGE.forNonprofits,
      className: (location.pathname === "/about/get-started" || location.pathname === "/about/invite-reviews" || location.pathname === "/about/showcase-reviews" || location.pathname === "/about/greatnonprofits-badge" || location.pathname === "/about/donations" || location.pathname === "/about/nonprofit-success-stories" || location.pathname === "/about/elliott-advocacy" || location.pathname === "/lady-freethinker") ? "active" : "",
      data: [
        {
          url: import.meta.env.VITE_CMS_URL + "about/claim-your-nonprofit/",
          name: MESSAGE.claimYourNonprofit,
        },
        {
          url: import.meta.env.VITE_CMS_URL + "about/invite-reviews/",
          name: MESSAGE.inviteReviews,
        },
        {
          url: import.meta.env.VITE_CMS_URL + "about/showcase-reviews/",
          name: MESSAGE.showcaseReviews,
        },
        {
          url: import.meta.env.VITE_CMS_URL + "about/great-nonprofit-badge/",
          name: MESSAGE.theGreatNonprofitsBadge,
        },
        {
          url: import.meta.env.VITE_CMS_URL + "about/get-donations/",
          name: MESSAGE.getDonations,
        },
        {
          url: import.meta.env.VITE_CMS_URL + "about/nonprofit-success-stories/",
          name: MESSAGE.nonprofitSuccessStories,
        },
        {
          url: import.meta.env.VITE_CMS_URL + "about/elliott-advocacy/",
          name: MESSAGE.elliottAdvocacy,
        },
        // {
        //   url: import.meta.env.VITE_CMS_URL + "about/lady-freethinker/",
        //   name: MESSAGE.ladyFreethinker,
        // },
      ],
    },
    {
      title: MESSAGE.aboutUs,
      className: (location.pathname === "/about" || location.pathname === "/about/about/board-members" || location.pathname === "/about/team" || location.pathname === "/advisory-board" || location.pathname === "/our-story" || location.pathname === "/about/press" || location.pathname === "/about/donate-to-us" || location.pathname === "/about/our-supporters" || location.pathname === "/about/careers" || location.pathname === "/about/contact-us" || location.pathname === "/about/endorsements" || location.pathname === "/about/sponsors") ? "active" : "",
      data: [
        {
          url: import.meta.env.VITE_CMS_URL + "",
          name: MESSAGE.aboutGreatNonprofit,
        },
        {
          url: import.meta.env.VITE_CMS_URL + "about/board-members/",
          name: MESSAGE.boardMembers,
        },
        {
          url: import.meta.env.VITE_CMS_URL + "about/team-members/",
          name: MESSAGE.team,
        },
        {
          url: import.meta.env.VITE_CMS_URL + "about/advisory-board/",
          name: MESSAGE.advisoryBoard,
        },
        {
          url: import.meta.env.VITE_CMS_URL + "about/our-story/",
          name: MESSAGE.ourStory,
        },
        {
          url: import.meta.env.VITE_CMS_URL + "about/press/",
          name: MESSAGE.press,
        },
        {
          url: import.meta.env.VITE_CMS_URL + "about/donate-to-us/",
          name: MESSAGE.donateToUs,
        },
        {
          url: import.meta.env.VITE_CMS_URL + "about/our-supporters/",
          name: MESSAGE.ourSupporters,
        },
        {
          url: import.meta.env.VITE_CMS_URL + "about/careers/",
          name: MESSAGE.careers,
        },
        {
          url: import.meta.env.VITE_CONTACT_US + "contact-us/",
          name: MESSAGE.contactUs,
        },
        {
          url: "https://new.greatnonprofits.org/pages/about/endorsements/",
          name: MESSAGE.endorsements,
        },
        {
          url: import.meta.env.VITE_CMS_URL + "about/sponsors/",
          name: MESSAGE.sponsors,
        },
      ],
    },
    {
      title: MESSAGE.solutions,
      className: (location.pathname === "/about/partner-solutions" || location.pathname === "/about/greatnonprofits-api") ? "active" : "",
      data: [
        {
          url: import.meta.env.VITE_CMS_URL + "about/solutions/",
          name: MESSAGE.solutions,
        },
        {
          url: "https://communityconnectlabs.com//",
          name: MESSAGE.communityConnect,
        },
        {
          url: import.meta.env.VITE_CMS_URL + "about/api-data-integration/",
          name: MESSAGE.apiAndDataIntegration,
        },
      ],
    },
    {
      title: MESSAGE.getInvolved,
      className: (location.pathname === "/nominate" || location.pathname === "/about/donate-to-nonprofits" || location.pathname === "/nominate" || location.pathname === "/explore-cities" || location.pathname === "/discover-causes" || location.pathname === "/about/link-to-us" || location.pathname === "/about/advertising") ? "active" : "",
      data: [
        {
          url: "/write-review",
          name: MESSAGE.createReview,
        },
        {
          url: import.meta.env.VITE_CMS_URL + "about/donate-to-nonprofits/",
          name: MESSAGE.donateToNonprofits,
        },
        {
          url: import.meta.env.VITE_CMS_URL + "toprated/volunteer/",
          name: MESSAGE.volunteer,
        },
        {
          url: import.meta.env.VITE_CMS_URL + "about/top-causes/",
          name: MESSAGE.discoverTopCauses,
        },
        {
          url: import.meta.env.VITE_CMS_URL + "about/top-cities/",
          name: MESSAGE.exploreTopCities,
        },
        {
          url: import.meta.env.VITE_CMS_URL + "about/link-to-us/",
          name: MESSAGE.linkToUs,
        },
        {
          url: import.meta.env.VITE_CMS_URL + "about/advertising/",
          name: MESSAGE.advertising,
        },
      ],
    },
  ];

  const handleMouseEnter = (index: number) => {
    setIsHovered(index);
  };

  const handleMouseLeave = () => {
    setIsHovered(null);
  };
  return (
    <CustomeDropmain>
      {headers?.map((header, index) => (
        <NavDropdown
          key={index + 1}
          title={header?.title}
          show={isHovered === index}
          //onMouseEnter={() => setIsHovered(index)}
          onMouseEnter={() => handleMouseEnter(index)}
          onMouseLeave={handleMouseLeave}
          // onMouseLeave={() => setIsHovered(null)}
          className={header?.className}
        >
          <NavcustomeDropdown>
            <Drodownitemlist className="drop-on-hover">
              <DonateNow />
              <CenterMenu>
                <NavDropdownItems data={header?.data} title={header?.title} />
              </CenterMenu>
            </Drodownitemlist>
          </NavcustomeDropdown>
        </NavDropdown>
      ))}
    </CustomeDropmain>
  );
};
export default CustomDropdown;
